import { Component, OnDestroy, OnInit } from '@angular/core';
import { toast } from 'angular2-materialize';
import { Subscription } from 'rxjs';
import { NgTable } from '../../coms';
import { AutoService, FsAuto } from '../../services/auto.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-crud-auto',
  templateUrl: './crud-auto.component.html',
  styleUrls: ['./crud-auto.component.css']
})
export class CrudAutoComponent implements OnInit, OnDestroy {
  lodaded: boolean = false;

  autos: FsAuto[] = [];
  autoSub: Subscription;
  autoTable: NgTable<FsAuto & {name: string}> = new NgTable({
    columns: [],
    data: [],
  });

  pickadateParams = Utils.pickadateParams();
  
  constructor(
    private service: AutoService,
  ) { }

  ngOnInit() {
    this.autoSub = this.service.getAutos$().subscribe(autos => {
      this.autos = autos.map(auto => ({...auto}));
      this.autoTable.data = this.autos.map(auto => ({name: auto.placa, ...auto}));
      this.autoTable.onChangeTable(this.autoTable.config);
    });
  }
  ngOnDestroy(){
    this.autoSub && this.autoSub.unsubscribe();
  }

  autoDataLabels: {[K in keyof FsAuto]: string} = {
    color: 'Color',
    model: 'Modelo',
    placa: 'Placa',
    year: 'Año',
    insuranceCompany: 'Compañía Aseguradora',
    polizaNumber: 'Número de Póliza',
    datePolizaEnd: 'Fecha Vencimiento Póliza',
  };
  autoData: FsAuto = {
    color: '',
    model: '',
    placa: '',
    year: '',
    insuranceCompany: '',
    polizaNumber: '',
    datePolizaEnd: Utils.today,
  };
  autoId: string = '';
  autoDataFormMode: 'touch' | 'update' = 'touch';
  prepareAutoDataForm(mode: CrudAutoComponent['autoDataFormMode'] = 'touch', auto?: FsAuto){
    this.autoDataFormMode = mode;
    if(mode == 'touch'){
      this.autoId = '';
      for(let key in this.autoData) this.autoData[key] = '';
    }else if(mode == 'update' && auto){
      let {id, active, ...autoData} = auto;
      this.autoId = id;
      this.autoData = {...autoData};
    }
  }
  onAutoDataFormCancel(){
    this.prepareAutoDataForm('touch');
  }
  async onAutoDataFormSubmit(){
    for(let key in this.autoData) if(!this.autoData[key]) return toast(`Falta campo ${this.autoDataLabels[key]}.`, 2000);
    if(this.autoDataFormMode == 'touch') await this.touchAuto();
    else if(this.autoDataFormMode == 'update') await this.updateAuto();
  }
  async onAutoDataCancel(){
    this.autoId = '';
    this.autoDataFormMode = 'touch';
    for(let key in this.autoData) if(key != 'datePolizaEnd') this.autoData[key] = '';
  }
  async touchAuto(){
    let result = await this.service.touchAuto(this.autoData);
    toast(`${result ? 'Éxito' : 'Error'} al crear el automóvil.`, 3000);
  }
  async updateAuto(){
    if(!this.autoId) return toast('No se puede actualizar.', 3000);
    let result = await this.service.updateAuto(this.autoId, this.autoData);
    toast(`${result ? 'Éxito' : 'Error'} al editar el automóvil.`, 3000);
    if(result) this.onAutoDataCancel();
  }
  onAutoUpdate(auto: FsAuto){
    if(!auto.id) return toast('No se puede actualizar.', 2000);
    this.autoId = auto.id;
    this.autoDataFormMode = 'update';
    for(let key in this.autoData) this.autoData[key] = auto[key];
  }

}
